import { useMediaQuery } from '@mui/material';
export const useBreakpoints = () => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return { isMobile };
};
